module.exports = __webpack_public_path__ + "img/max-file-content-approve.0eec7c3c.svg";